import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsProgramPayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM;
    id: string;
    attributes: {
      data: Array<{
        program_id: string | null;
        program_title: string;
        project_status_group: string;
        project_count: number;
        program_total_count: number;
      }>;
    };
  };
}

export const parseProjectsProgramPayload = (
  payload: BaseInsightPayload
): ProjectsProgramPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      program_id: string | null;
      program_title: string;
      project_status_group: string;
      project_count: number;
      program_total_count: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_PROGRAM,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
